/**
 * Step 6: If coil/filter/er_wheel are required, resize AHU based on minimum cross-sections
 */
import { processSizerAndSizeAHU } from '../../designAHU.sizer';
import { IBotData, IAHUParams, ITunnel, SizerResult } from '../../../../models';

export async function step6ResizeForComponents(
  botData: IBotData,
  ahuParams: IAHUParams,
  tunnel: ITunnel,
  index: number,
  thickness: number | null,
  casingInsulationId: number | null,
  getOptions: () => { signal?: AbortSignal },
  onProgress?: (coefficient: number) => void,
): Promise<SizerResult> {
  const sizerResult = await processSizerAndSizeAHU(
    botData,
    ahuParams,
    tunnel,
    index,
    thickness,
    casingInsulationId,
    getOptions,
    onProgress,
  );

  return {
    sizerSettings: sizerResult.sizerSettings,
    ahuParamsResult: sizerResult.ahuParamsResult,
    thickness: sizerResult.thickness,
    casingInsulationId: sizerResult.casingInsulationId,
    tunnel: sizerResult.tunnel,
  };
}
